import { Badge, MenuItem, Popover, Select, Box } from "@mui/material"
import { useState, useEffect, useMemo, useRef, useCallback } from "react"
import { IconButton } from '@mui/material';
import Divider from '@mui/material/Divider';
import { RuleTypeBadge } from "./components/rule-type-badge";
import { FloatingAlert } from "./components/floating-alert";
import CheckIcon from '@mui/icons-material/Check';
import { BellIcon } from "src/assets/icons/BellIcon";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import useApi from "src/hooks/useApi";
import services from "src/api/service";
import InfiniteScroll from 'react-infinite-scroll-component';
import SpinnerIcon from "src/assets/icons/SpinnerIcon";
import { onValue, ref } from "firebase/database";
import { database } from "src/utils/firebase";
import { getDspDetails } from 'src/views/pages/utils';
import { isUserFromAllowedDomain } from 'src/utils/emailUtils';


const TIME_PRESET_OPTIONS = [
    { value: 'Today', label: 'Today' },
    { value: 'Yesterday', label: 'Yesterday' },
    { value: 'Last 7 Days', label: 'Last 7 Days' },
    { value: 'Last 14 Days', label: 'Last 14 Days' },
    { value: 'Last 30 Days', label: 'Last 30 Days' },
    { value: 'Last 3 Months', label: 'Last 3 Months' },
    { value: 'Last 6 Months', label: 'Last 6 Months' }
];

const getCurrentTime = (time,timezone) => {
    if (!time) return '';

    const now = new Date();
    const pastDate = new Date(time);
    const diffInMilliseconds = now - pastDate;
    const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));
    const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));

    // Within 1 hour: show minutes
    if (diffInHours < 1) {
        return `${diffInMinutes} mins ago`;
    }

    // Within 24 hours: show hours
    if (diffInHours < 24) {
        return `${diffInHours} hours ago`;
    }

    // After 24 hours: show formatted date
    return pastDate.toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        timeZone: timezone
    });
};

// ... existing code ...

const getCurrentDate = (selectedMenu, timezone) => {
    const now = new Date();
    const fromDate = new Date();
    const toDate = new Date();

    switch (selectedMenu) {
        case 'Today':
            fromDate.setHours(0, 0, 0, 0);
            toDate.setHours(23, 59, 59, 999);
            break;

        case 'Yesterday':
            // Set fromDate to the start of yesterday
            fromDate.setDate(now.getDate() - 1);
            fromDate.setHours(0, 0, 0, 0); // Set time to midnight (start of the day)

            // Set toDate to the end of yesterday
            toDate.setDate(now.getDate() - 1);
            toDate.setHours(23, 59, 59, 999); // Set time to the last millisecond of the day
            break;

        case 'Last 7 Days':
            // Calculate from yesterday (hence -7 instead of -6)
            fromDate.setDate(now.getDate() - 7); // -7 to exclude today and start from yesterday
            fromDate.setHours(0, 0, 0, 0); // Start from midnight of that day
            toDate.setDate(now.getDate() - 1); // Set to yesterday (exclude today)
            toDate.setHours(23, 59, 59, 999); // End at the last moment of yesterday
            break;

        case 'Last 14 Days':
            // Calculate from yesterday (hence -14 instead of -13)
            fromDate.setDate(now.getDate() - 14); // -14 to exclude today and start from 13 days ago
            fromDate.setHours(0, 0, 0, 0); // Start from midnight of that day
            toDate.setDate(now.getDate() - 1); // Set to yesterday (exclude today)
            toDate.setHours(23, 59, 59, 999); // End at the last moment of yesterday
            break;

        case 'Last 30 Days':
            // Calculate from yesterday (hence -30 instead of -29)
            fromDate.setDate(now.getDate() - 30); // -30 to exclude today and start from 29 days ago
            fromDate.setHours(0, 0, 0, 0); // Start from midnight of that day
            toDate.setDate(now.getDate() - 1); // Set to yesterday (exclude today)
            toDate.setHours(23, 59, 59, 999); // End at the last moment of yesterday
            break;

        case 'Last 3 Months':
            // Start calculation from yesterday's date
            fromDate.setMonth(now.getMonth() - 3); // -3 to exclude this month, starting from 3 months ago
            fromDate.setDate(1); // Start from the 1st of the month
            fromDate.setHours(0, 0, 0, 0); // Start from midnight
            toDate.setDate(now.getDate() - 1); // Set to yesterday (exclude today)
            toDate.setHours(23, 59, 59, 999); // End at the last moment of yesterday
            break;

        case 'Last 6 Months':
            // Start calculation from yesterday's date
            fromDate.setMonth(now.getMonth() - 6); // -6 to exclude this month, starting from 6 months ago
            fromDate.setDate(1); // Start from the 1st of the month
            fromDate.setHours(0, 0, 0, 0); // Start from midnight
            toDate.setDate(now.getDate() - 1); // Set to yesterday (exclude today)
            toDate.setHours(23, 59, 59, 999); // End at the last moment of yesterday
            break;

        default:
            fromDate.setHours(0, 0, 0, 0);
            toDate.setHours(23, 59, 59, 999);
    }

    // Format dates as YYYY-MM-DD with provided timezone
    const formatDate = (date) => {
        const dateInTZ = timezone ? new Date(date.toLocaleString('en-US', { timeZone: timezone })) : date;

        const year = dateInTZ.getFullYear();
        const month = String(dateInTZ.getMonth() + 1).padStart(2, '0');
        const day = String(dateInTZ.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    };

    return {
        fromDate: formatDate(fromDate),
        toDate: formatDate(toDate)
    };
};




export const Notification = () => {
    const fetchNotificatioList = useApi(services.postService);
    const fetchUpdateNotificatioList = useApi(services.postService);
    const [anchorEl, setAnchorEl] = useState(null);
    const [alertOpen, setAlertOpen] = useState(false);
    const [menuSelected, setMenuSelected] = useState('Today')
    const [notificationData, setNotificationData] = useState();
    const [totalCount, setTotalCount] = useState(0);
    const [page, setPage] = useState(1);
    const [isMainPageLoading, setIsMainPageLoading] = useState(false);
    const [blinker, setBlinker] = useState(false);
    const [selectedTab, setSelectedTab] = useState('ruleBasedAutomation'); // 'ruleBasedAutomation' or 'dayParting'
    const isAmazonDSP = window.location.href.indexOf('/amazon-dsp') > -1

    const userProfile = useMemo(() => JSON.parse(sessionStorage.getItem('selectedProfileId')), []);
    const masterFilter = useMemo(() => JSON.parse(sessionStorage.getItem('master-account-filters')) || {}, []);
    const userProfileGroup = useMemo(() => JSON.parse(sessionStorage.getItem('selectedGroupedProfileId')), []);
    const isGroupAccount = useMemo(() => userProfile?.ams?.groupedAccounts?.length > 0, [userProfile?.ams?.groupedAccounts]);
    const dspDetails = userProfile?.dsp ? getDspDetails(userProfile, masterFilter) :{};

    const masterAdAccounts = useMemo(() => {
        return [ userProfile, ...(userProfile?.ams?.groupedAccounts && userProfile?.ams?.groupedAccounts?.length > 0 ? userProfile?.ams?.groupedAccounts  : [])]
    }, [userProfile])
    const profileIds = useMemo(() => {
        if (isGroupAccount) {
            const filterData = masterFilter[userProfile.profileId];
            if (!filterData) {
                return [userProfile?.profileId];
            }
            return filterData
                .filter((filterItem) => filterItem.level == 'ams' && filterItem?.keywords?.length > 0)
                .map((filterItem) => filterItem.keywords)
                .flat();
        } else if (isAmazonDSP) {
            return [ dspDetails?.dspId] || []
        }
        return [userProfile?.profileId];
    }, [isGroupAccount, masterFilter, userProfile])

    const notificationOpen = Boolean(anchorEl);

    const getNotifications = useCallback(() => {
        const { fromDate, toDate } = getCurrentDate(menuSelected, userProfile?.timezone);
        page === 1 && setIsMainPageLoading(true)
        fetchNotificatioList.request({
            url: isAmazonDSP ? '/dsp/listRuleNotification' : '/amazon/listRuleNotification',
            nodeAPI: 1,
            payload: {
                page: page,
                limit: 10,
                start_date: fromDate,
                end_date: toDate,
                ruleType: isAmazonDSP
                    ? (selectedTab == 'ruleBasedAutomation' ? 'DSPRuleBasedAutomation' : selectedTab == 'dayparting' ? 'DSPDayParting' : 'DSPSmartCampaigns')
                    : (selectedTab == 'ruleBasedAutomation' ? 'ruleBasedAutomation' : 'dayParting'),                
                ...(isAmazonDSP ? { 
                dsp_Id : dspDetails?.dspId
                } 
                : isGroupAccount ? {
                addgroup_filters: [
                        {
                            keywords: profileIds,
                            level: "ams"
                        }
                    ]
                } : { profile_id: String(profileIds) })
            }
        });
    }, [menuSelected, userProfile?.timezone, page, isGroupAccount, profileIds, fetchNotificatioList, selectedTab]);
    
    useEffect(() => {
        getNotifications()
    }, [menuSelected, page, selectedTab])

    const updateNotificationData = useCallback((result, totalCount) => {
        setTotalCount(totalCount || 0)
        setNotificationData((prevData) => {
            if (page === 1) {
                return result;
            } else {
                return [...prevData, ...result];
            }
        })
        page === 1 && setIsMainPageLoading(false)
    }, [fetchNotificatioList, page]);

    useEffect(() => {
        const { loading, data } = fetchNotificatioList;
        if (!loading && data && data?.data) {
            const { result = [], totalCount = 0 } = data?.data;
            if (result) {
                updateNotificationData(result, totalCount)
            }
        }
    }, [fetchNotificatioList.loading])

    const recentData = useMemo(() => {
        return notificationData?.filter(item => !item?.read) || [];
    }, [notificationData]);

    const olderData = useMemo(() => {
        return notificationData?.filter(item => item?.read) || [];
    }, [notificationData]);

    const findTypeRule = (typeRule) => {
        const ruleTypes = {
            'Budget': 'budget',
            'Bid': 'bid',
            'Status': 'status',
            'Placement': 'placement',
            'negativeSearchTerm': 'searchterm-negation',
            'SearchTerm': 'searchterm-harvesting',
            'Product': 'advertised-product',
            'Audience': 'audience',
            'SupplySource': 'supplysource',
            'Location': 'location',
            'Placement': 'placement',

        };
        return ruleTypes[typeRule] || '';
    };

    const handleSingleNotificationUpdate = useCallback((notificationItem) => {
        const { notificationId, read, configuration } = notificationItem
        const { typeRule, ruleCheckId, ruleId, rule, categoryLevel, profileId } = configuration?.ruleDetails
        const id = configuration?.ruleDetails?.scheduledSlotIdDetails?.id || configuration?.ruleDetails?.campaignDetails?.[0]?.adGroupId ||configuration?.ruleDetails?.campaignDetails?.[0]?.campaignId ||'';
        const { fromDate, toDate } = getCurrentDate(menuSelected, userProfile?.timezone);
        if (!read) {
            fetchUpdateNotificatioList.request({
                url: isAmazonDSP ? '/dsp/updateRuleNotification' : '/amazon/updateRuleNotification',
                nodeAPI: 1,
                payload: {
                    start_date: fromDate,
                    end_date: toDate,
                    notification_id: notificationId,
                    ...(isAmazonDSP ? { 
                    dsp_Id : dspDetails?.dspId
                    } 
                    :isGroupAccount ? {
                    addgroup_filters: [
                            {
                                keywords: profileIds,
                                level: "ams"
                            }
                        ]
                    } : { profile_id: String(profileIds) })
                }
            });

            setNotificationData(prevData => {
                return prevData.map(notification => {
                    if (notification?.notificationId === notificationId) {
                        return { ...notification, read: true };
                    }
                    return notification;
                });
            });
        }

        const ruleType = findTypeRule(typeRule)

        if (rule == 'ruleBasedAutomation') {
            localStorage.setItem(`ruleBasedAutomation-${ruleType}-${ruleId}-${ruleCheckId}`, JSON.stringify(notificationItem))
            if (isGroupAccount && profileId != userProfileGroup?.profileId) {
                const isAvailableCurrentProfile = masterAdAccounts?.find((profile) => profile?.profileId == profileId)
                if (isAvailableCurrentProfile?.profileId) {
                    sessionStorage.setItem('selectedGroupedProfileId',JSON.stringify(isAvailableCurrentProfile))
                }
            }
            window.open(`/amazon-automated-rules/${ruleType}/view-logs-notifications/${ruleId}/details/${ruleCheckId}`)
        }

        if (rule == 'dayParting') {
            localStorage.setItem(`dayParting-${typeRule}-${id}-${categoryLevel}`, JSON.stringify(notificationItem))
            if (isGroupAccount && profileId != userProfileGroup?.profileId) {
                const isAvailableCurrentProfile = masterAdAccounts?.find((profile) => profile?.profileId == profileId)
                if (isAvailableCurrentProfile?.profileId) {
                    sessionStorage.setItem('selectedGroupedProfileId',JSON.stringify(isAvailableCurrentProfile))
                }
            }
            window.open(`/amazon-dayparting-schedule-log/${typeRule}/${id}/${categoryLevel}`)
        }
        if (rule == 'DSPRuleBasedAutomation') {
            localStorage.setItem(`DSPRuleBasedAutomation-${ruleType}-${ruleId}-${ruleCheckId}`, JSON.stringify(notificationItem))
            window.open(`/amazon-dsp-automated-rules/${ruleType}/view-logs-notifications/${ruleId}/details/${ruleCheckId}`)
        }

        if (rule == 'DSPDayParting') {
            localStorage.setItem(`DSPDayParting-${id}-${categoryLevel}`, JSON.stringify(notificationItem))
            window.open(`/amazon-dsp-dayparting-schedule-log/${typeRule}/${id}/${categoryLevel}`)
        }

        if(rule == 'DSPSmartCampaigns') {
            localStorage.setItem(`DSPSmartCampaigns-${typeRule}-${id}-${categoryLevel}`, JSON.stringify(notificationItem))
            if(configuration?.ruleDetails?.campaignDetails?.[0]?.adGroupId) {
                window.open(`/amazon-dsp/adgroup/${configuration?.ruleDetails?.campaignDetails?.[0]?.adGroupId}/update`)
            } else if(configuration?.ruleDetails?.campaignDetails?.[0]?.campaignId){
                window.open(`/amazon-dsp/campaign/${configuration?.ruleDetails?.campaignDetails?.[0]?.campaignId}/update`)
            }
             
        }
    }, [userProfileGroup, masterAdAccounts, isGroupAccount, menuSelected, userProfile])

    const NotificationItems = useCallback(({ prop }) => {
        const { createdAt, notificationId, read, configuration, count } = prop
        const { ruleDetails } = configuration
        const { typeRule, ruleName, scheduleId, categoryLevel, rule } = ruleDetails
        const { heading, description } = getDspSmartCampaignInfo(ruleDetails);
        return (
            <div key={notificationId} className={`notification-card-item cursor-pointer ${fetchUpdateNotificatioList.loading ? 'disabled' : ''}`} onClick={() => handleSingleNotificationUpdate(prop)}>
                <div className="badge-container">
                    <RuleTypeBadge label={typeRule || rule == 'DSPSmartCampaigns' && 'DSP Smart Campaigns'} />
                </div>
                <div className="notification-card-header">
                    {rule == 'DSPSmartCampaigns' ? 
                    <span className="notification-card-title">{heading}</span> :
                    <span className="notification-card-title">{`${count} changes have been ${scheduleId && (categoryLevel == 'update' || categoryLevel == 'revert') ? `${categoryLevel}${categoryLevel == 'revert' ? 'ed' : 'd'}` : 'made'}`}</span>
                    }
                    <div className="notification-card-time">
                        <span className="time-text">{getCurrentTime(createdAt, userProfile.timezone)}</span>
                        {!read && <div className="status-indicator" />}
                    </div>
                </div>
                <div className="notification-card-description">
                    {rule == 'DSPSmartCampaigns' ?
                    <div className="notification-card-description">
                      {rule == 'DSPSmartCampaigns' ? (
                        <div
                          className="notification-description"
                          dangerouslySetInnerHTML={{ __html: description }}
                        />
                      ) : (
                        <span className="notification-description">
                          <span style={{ fontWeight: 500 }}>{ruleName}</span> rule has been changed.
                        </span>
                      )}
                    </div>
                    :
                     <span className="notification-description"><span style={{ fontWeight: 500 }}>{ruleName}</span> <span>rule has been changed.</span></span>
                   }
                </div>
            </div>
        );
    },[userProfile]);

    const handlePopoverOpen = (e) => {
        setAnchorEl(e.currentTarget);
    }

    const handlePopoverClose = () => {
        //reset the popover
        setPage(1);
        setMenuSelected('Today');
        setAnchorEl(null);
    }

    const handleMarkAllAsRead = useCallback(() => {
        const { fromDate, toDate } = getCurrentDate(menuSelected, userProfile?.timezone);
        setIsMainPageLoading(true)
        fetchUpdateNotificatioList.request({
            url: isAmazonDSP ? '/dsp/updateRuleNotification' : '/amazon/updateRuleNotification',
            nodeAPI: 1,
            payload: {
                start_date: fromDate,
                end_date: toDate,
                bulkUpdate: true,
                ruleType: isAmazonDSP
                ? (selectedTab == 'ruleBasedAutomation' ? 'DSPRuleBasedAutomation' : selectedTab == 'dayparting' ? 'DSPDayParting' : 'DSPSmartCampaigns')
                : (selectedTab == 'ruleBasedAutomation' ? 'ruleBasedAutomation' : 'dayParting'),                
                ...(isAmazonDSP ? { 
                    dsp_Id : dspDetails?.dspId
                    } 
                    :isGroupAccount ? {
                    addgroup_filters: [
                        {
                            keywords: profileIds,
                            level: "ams"
                        }
                    ]
                } : { profile_id: String(profileIds) })
            }
        }).then(() => {
            getNotifications()
        })
    }, [isGroupAccount, profileIds, menuSelected, userProfile?.timezone, selectedTab]);
   

    const handleAlertClose = () => {
        setAlertOpen(false)
    };

    const handleMenuChange = (e) => {
        setPage(1)
        setMenuSelected(e.target.value)
    }

    const hasMoreData = useCallback(() => {
        if (notificationData?.length < totalCount && !fetchNotificatioList.loading) {
            setPage((prev) => prev + 1);
        }
    }, [notificationData?.length, totalCount, fetchNotificatioList.loading]);


    const listDataRef = useRef({});
    const firebaseConnectionRef = useRef([]);

    const setBlinkerOrNot = useCallback(() => {
        const anyProfileHasActiveRule = (Object.values(listDataRef.current).some(profile => {
            return profile.dayParting > 0 || profile.ruleBasedAutomation > 0;
        }));

        const hasUnreadNotifications = notificationData?.some(item => !item?.read) || false;
        if (anyProfileHasActiveRule || hasUnreadNotifications) {
            setBlinker(true)
        } else {
            setBlinker(false)
        }
    }, [notificationData, blinker]);

    const getTotalCount = () => {
        return Object.values(listDataRef.current).reduce((total, profile) => {
        if (isAmazonDSP) {
          return total + (profile.DSPDayParting || 0) + (profile.DSPRuleBasedAutomation || 0) + (profile.DSPSmartCampaigns);
        } else {
          return total + (profile.dayParting || 0) + (profile.ruleBasedAutomation || 0);
        }
      }, 0);
    };

    const setupFirebaseListeners = (profileId) => {
        const path = `${isAmazonDSP ? `/dsp/rule_notifications/${profileId}` : `/rule_notifications/${profileId}`}`;
        return ref(database, path);
    };


    const updateAlertOpen = () => {
        handlePopoverClose()
        setAlertOpen(true)
        setTimeout(() => {
            setAlertOpen(false)
        }, 5000)
    };

    useEffect(() => {
        const unsubscribers = [];
        listDataRef.current = {};
        firebaseConnectionRef.current = profileIds?.map(profileId => {
            return setupFirebaseListeners(profileId);
        });

        firebaseConnectionRef.current.forEach((ref, index) => {
            // Listener for changes in the profile's notification data
            const unsubscribe = onValue(ref, (snapshot) => {
                const data = snapshot.val();
                const profileId = profileIds[index]
                if (data && (data.dayParting > 0 || data.ruleBasedAutomation > 0 || data?.DSPDayParting > 0 || data?.DSPRuleBasedAutomation > 0 || data?.DSPSmartCampaigns > 0)) {
                    const { dayParting, ruleBasedAutomation, DSPDayParting, DSPRuleBasedAutomation, DSPSmartCampaigns } = data;
                    // Update the listDataRef for the current profile
                    listDataRef.current[profileId] = {
                        dayParting: dayParting || 0,
                        ruleBasedAutomation: ruleBasedAutomation || 0,
                        DSPDayParting: DSPDayParting || 0,
                        DSPRuleBasedAutomation: DSPRuleBasedAutomation || 0,
                        DSPSmartCampaigns: DSPSmartCampaigns || 0
                    };
                    if(index === profileIds.length - 1) {
                        setBlinkerOrNot()
                        updateAlertOpen()
                    }
                }
            });
            unsubscribers.push(unsubscribe);
        });

        return () => {
            // Unsubscribe from all Firebase listeners
            unsubscribers.forEach(unsubscribe => unsubscribe());
            firebaseConnectionRef.current = [];
            listDataRef.current = {};
        };

    }, [profileIds]);
    
    useEffect(() => {
        const handleClickOutside = (event) => {
            const popupElement = document.querySelector('.notification-container');
            const selectDropdownElement = document.querySelector('#notification-select-dropdown-menu');
            
            if (popupElement && 
                !popupElement.contains(event.target) && 
                !selectDropdownElement?.contains(event.target) &&
                notificationOpen) {
                handlePopoverClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [notificationOpen]);

function getDspSmartCampaignInfo(ruleDetails = {}) {
  const { categoryLevel, campaignDetails = [] } = ruleDetails;
  const firstCampaign = campaignDetails[0] || {};
  const {
    campaignName,
    creativeData = [],
    audienceData = [],
    asinData = [],
    adGroupName, 
  } = firstCampaign;

  let heading = "";
  let description = "";

  const getReason = (data) =>
    data?.[0]?.reason?.[0]?.replace(/<[^>]+>/g, "") || "Unknown reason";

  switch (categoryLevel) {
    case "DSP-SMART-CAMPAIGN-CREATIVE-FAILED": {
      heading = "Creative Failed";
      const reason = getReason(creativeData);

      description = `
        Creative validation failed for the campaign 
        <strong>${campaignName}</strong>. 
        Reason: ${reason}.
      `;
      break;
    }
    case "DSP-SMART-ADGROUP-ACTIVATED": {
      heading = "Smart Campaign is Now Live";

      description = `
        Your DSP campaign <strong>${campaignName}</strong> and 
         ad group <strong>${adGroupName}</strong> has been activated.
      `;
      break;
    }
    case "DSP-SMART-ADGROUP-INACTIVE": {
      heading = "Campaigns and Ad Groups have been Successfully Prepared";

      description = `
        The DSP Ad Group <strong>${adGroupName}</strong> inside 
        the campaign <strong>${campaignName}</strong> has been successfully prepared.
        You may now activate the ad groups at your convenience to begin serving ads.

      `;
      break;
    }
    case "DSP-SMART-CAMPAIGN-ASIN-FAILED": {
      heading = "ASIN Validation Failed";


      description = `
        One or more ASINs failed validation in the campaign 
        <strong>${campaignName}</strong>. 
      `;
      break;
    }
    case "DSP-SMART-CAMPAIGN-AUDIENCE-PROCESSING": {
      heading = "Audience Processing";


      description = `
        Audience <strong>${audienceData?.[0]?.audienceName}</strong> data is currently processing for the campaign 
        <strong>${campaignName}</strong>. 
      `;
      break;
    }
    case "DSP-SMART-CAMPAIGN-AUDIENCE-FAILED": {
      heading = "Audience Failed";

      const reason = getReason(audienceData);

      description = `
        Audience <strong>${audienceData?.[0]?.audienceName}</strong> processing failed for the campaign 
        <strong>${campaignName}</strong>. 
        Reason: ${audienceData?.[0]?.reason}.
      `;
      break;
    }
    case "DSP-SMART-CAMPAIGN-ACTIVATED": {
      heading = "Smart Campaign is Now Live";

      description = `
        Your DSP Smart Campaign <strong>${campaignName}</strong>
        is now live.
      `;
      break;
    }

    case "DSP-SMART-CAMPAIGN-ACTIVATION-FAILED": {
      heading = "Campaign Activation Failed";

      description = `
        Activation failed for the DSP Smart Campaign 
        <strong>${campaignName}</strong> and ad group <strong>${adGroupName}</strong>. 
        Reason: Activation Failed Due to Insufficient Wallet Balance.
      `;
      break;
    }

    default:
      heading = "DSP Notification";
      description = "Details about your DSP Smart Campaign are updated.";
  }

  return { heading, description };
}



console.log(recentData,notificationData,  'recentData');

    return (
        <div className={'notification-popover-component'}>
            <IconButton sx={{ backgroundColor: notificationOpen ? '#F6F6F6' : '#fff', padding: '6px' }} className="icon-button" onClick={handlePopoverOpen}>
                <Badge color="error" variant="dot" invisible={!blinker} className={blinker ? "blinking-badge" : ""}>
                    <BellIcon sx={{ fontSize: '8px' }} />
                </Badge>
            </IconButton>
            <div>
                <Popover
                    open={notificationOpen}
                    anchorEl={anchorEl}
                    onClose={handlePopoverClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    className="notification-popover-component"
                    PaperProps={{
                        sx: {
                            marginTop: '18px',
                            borderRadius: '15px',
                            maxWidth: '363px',
                            boxShadow: '-2px 4px 20.8px 0px rgba(0, 0, 0, 0.15)',
                            overflow: 'visible',
                            '&::before': { // Target the pseudo-element of the Paper itself
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                top: '-10px', // Adjust to align the triangle correctly
                                right: '11px',
                                width: '10px',
                                height: '10px',
                                borderStyle: 'solid',
                                borderWidth: '10px 15px 10px 0px',
                                borderColor: 'transparent #fff transparent transparent',
                                transform: 'rotate(90deg)',
                            },
                        },
                    }}
                >
                    <div className="notification-container">
                        <div className="notification-header">
                            <span>Notifications</span>
                        </div>
                        <div className="notification-controls">
                            <div style={{ position: 'relative', overflow: 'hidden' }}>
                                <Select disabled={fetchNotificatioList.loading || fetchUpdateNotificatioList.loading}
                                    value={menuSelected}
                                    onChange={handleMenuChange}
                                    displayEmpty
                                    inputProps={{ 'aria-label': 'Without label', style: { borderColor: 'transparent' } }}
                                    IconComponent={(props) => <KeyboardArrowDownIcon {...props} />}
                                    renderValue={(selected) => (
                                        <span>
                                            {selected}
                                        </span>
                                    )}
                                    sx={{
                                        width: '130px', // Increase the width for better layout
                                        height: '32px',
                                        fontFamily: "'Open Sans', sans-serif !important",
                                        fontSize: '12px !important',
                                        fontWeight: '600 !important',
                                        borderRadius: '5px',
                                        marginTop: '1px',
                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                            border: '1px solid #E4E4E4', // Prevent change on hover
                                        },
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            border: '1px solid #E4E4E4', // Fixed border color
                                        },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            border: '1px solid #E4E4E4', // Prevent change on focus
                                        },
                                        '&.MuiInputBase-root .MuiSelect-select': {
                                            border: 'none !important'
                                        },

                                    }}
                                    MenuProps={{
                                        id: 'notification-select-dropdown-menu'
                                    }}
                                >
                                    <MenuItem value="Time Preset" sx={{
                                        margin: '0px 10px !important',
                                        color: '#0092FF !important',
                                        pointerEvents: 'none',
                                        fontFamily: "'Open Sans', sans-serif !important",
                                        fontSize: '12px !important',
                                        fontWeight: '600 !important',
                                        padding: '6px 16px !important',
                                    }}>
                                        Time Preset
                                    </MenuItem>
                                    {TIME_PRESET_OPTIONS.map((option) => (
                                        <MenuItem
                                            key={option.value}
                                            value={option.value}
                                            sx={{
                                                '&.MuiButtonBase-root': {
                                                      display: 'grid !important',
                                                      color: menuSelected === option.value ? '#fff !important' : '#000',
                                                      padding: '6px 16px !important',
                                                      justifyContent: 'start !important'
                                                },
                                                margin: '0px 10px !important',
                                                backgroundColor: menuSelected === option.value ? '#0092FF !important' : '',
                                                borderRadius: '4px !important',
                                                fontSize: '12px !important',
                                                fontFamily: "'Open Sans', sans-serif !important",
                                                fontWeight: menuSelected === option.value ? '600 !important' : '400 !important',
                                            }}
                                        >
                                            {menuSelected === option.value ? (
                                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                                    <CheckIcon sx={{ marginRight: '4px', fontSize: '16px' }} />
                                                    {option.label}
                                                </span>
                                            ) : (
                                                option.label
                                            )}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </div>
                            {recentData?.length > 0 && <div className={`mark-all-read ${fetchUpdateNotificatioList.loading || fetchNotificatioList.loading ? 'disabled' : ''}`} onClick={handleMarkAllAsRead}>
                                <div className="icon">
                                    <DoneAllIcon sx={{ fontSize: '16px', color: '#3069CC' }} />
                                </div>
                                <span>Mark all as read</span>
                            </div>}
                        </div>
                        <Box p={'0px 8px 0px 15px'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                            <Box className={`${selectedTab == 'ruleBasedAutomation'  ? 'notification-popover-component-selected-tab' : 'notification-popover-component-unseleceted-tab'} notification-popover-component-tab-switch`} py={'15px'} onClick={()=> selectedTab && (setSelectedTab('ruleBasedAutomation'), setPage(1))}>
                                <span className={`${selectedTab == 'ruleBasedAutomation'  ? 'notification-popover-component-selected-switch-content' : 'notification-popover-component-unselected-switch-content'} f-12`}>{isAmazonDSP ? 'Rule Based' : 'Rule Based Automation'}</span>
                            </Box>
                            {!(isAmazonDSP && !isUserFromAllowedDomain()) && (
                            <Box className={`${selectedTab == 'dayparting'  ? 'notification-popover-component-selected-tab' : 'notification-popover-component-unseleceted-tab'} notification-popover-component-tab-switch`} py={'15px'} onClick={()=> selectedTab && (setSelectedTab('dayparting'), setPage(1))}>
                                <span className={`${selectedTab == 'dayparting'  ? 'notification-popover-component-selected-switch-content' : 'notification-popover-component-unselected-switch-content'} f-12`}>Dayparting</span>
                            </Box>
                            )}
                            {(isAmazonDSP) && (
                            <Box className={`${selectedTab == 'smartCampaigns'  ? 'notification-popover-component-selected-tab' : 'notification-popover-component-unseleceted-tab'} notification-popover-component-tab-switch`} py={'15px'} onClick={()=> selectedTab && (setSelectedTab('smartCampaigns'), setPage(1))}>
                                <span className={`${selectedTab == 'smartCampaigns'  ? 'notification-popover-component-selected-switch-content' : 'notification-popover-component-unselected-switch-content'} f-12`}>Smart Campaigns</span>
                            </Box>
                            )}
                        </Box>
                        <div style={{ padding: '0px 8px 15px 15px' }}>
                            {isMainPageLoading ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '350px', backgroundColor: '#F1F4F8' }}>
                                <SpinnerIcon width={22} height={22} className="spinner" style={{ color: '#1877f2' }} />
                            </div> : recentData?.length <= 0 && olderData?.length <= 0 ?
                                <div className='notification-popover-component-empty-message'>
                                    No Notifications Available
                                </div> :
                                <Box className={'notification-popover-component-scroll-cont'}>
                                <InfiniteScroll
                                    className="custom-scroll-notificationTab"
                                    dataLength={notificationData?.length || 0}
                                    next={hasMoreData}
                                    hasMore={notificationData?.length < totalCount}
                                    scrollThreshold="90%"
                                    height={400}
                                    style={{ overflow: 'auto' }}
                                    loader={
                                        fetchNotificatioList.loading ? (
                                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '4.5px', marginBottom: '4.5px' }}>
                                                <SpinnerIcon width={22} height={22} className="spinner" style={{ color: '#1877f2' }} />
                                            </div>
                                        ) : null
                                    }
                                >
                                    <div>
                                        {recentData?.length > 0 && <div>
                                            <div className="section-title">Recent</div>
                                            {recentData?.map((notification, index) => (
                                                <NotificationItems key={notification.notificationId} prop={notification} />
                                            ))}
                                        </div>}
                                        {(recentData?.length > 0 && olderData?.length > 0) && <Divider className="divider" />}
                                        {olderData?.length > 0 && <div>
                                            <div className="section-title">Older</div>
                                            {olderData?.map((notification, index) => (
                                                <NotificationItems key={notification.notificationId} prop={notification} />
                                            ))}
                                        </div>}
                                    </div>
                                </InfiniteScroll></Box>}
                        </div>
                    </div>
                </Popover>
            </div>
            <FloatingAlert
                open={alertOpen}
                notificationCount={getTotalCount()}
                title={'rules have been changed'}
                description={''}
                onClose={handleAlertClose}
            />
        </div>

    )
}